// extracted by mini-css-extract-plugin
export default {"content":"footer_content__Px8MT","date":"footer_date__4vw17"};